import styled from 'styled-components';
import { P } from '../base/typography';
import { H3 } from '../base/typography/headings';

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	background-color: #fdf4f5;
	border: 1px solid #ffc1c4;
	margin-top: 1rem;
	height: 30rem;
	padding-top: 5rem;
	text-align: center;
`;

export const Heading = styled(H3)``;

export const Text = styled(P)`
	padding-top: 1rem;
`;
